/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderDetailsQuery } from '../../models/get-order-details-query';
import { GetOrderDetailsQueryResult } from '../../models/get-order-details-query-result';

export interface ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Params {
      body?: GetOrderDetailsQuery
}

export function apiNurseryManagerOrderDetailsGetOrderDetailsPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsGetOrderDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsGetOrderDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderDetailsQueryResult>;
    })
  );
}

apiNurseryManagerOrderDetailsGetOrderDetailsPost.PATH = '/api/NurseryManager/OrderDetails/GetOrderDetails';
